import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="section-padding bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            海量视频资源按类别精心整理，轻松找到你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/60 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1 text-center line-clamp-2">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}